import React from 'react';
import './index.scss';
import { CloseCircleOutlined } from '@ant-design/icons';

const VideoDirectionWithBtn = ({
  direction,
  showRecommendCloseBtnText,
  showRecommendCloseBtnIcon,
  closeVideo,
}: {
  direction: string;
  showRecommendCloseBtnText: boolean;
  showRecommendCloseBtnIcon: boolean;
  closeVideo: AnyFunc;
}) => {
  const className = showRecommendCloseBtnText ? 'color-red' : '';

  return (
    <span
      className={`video-direction-with-btn ${className}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        closeVideo();
      }}
    >
      <span>{direction}</span>
      {showRecommendCloseBtnText && <span>关闭</span>}
      {showRecommendCloseBtnIcon && (
        <span>
          <CloseCircleOutlined style={{ color: 'white', fontSize: '24px' }} />
        </span>
      )}
    </span>
  );
};

export default React.memo(VideoDirectionWithBtn);
